import React from 'react'
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { List, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { removeUpdateSetting } from './UpdateSettingSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';

export default function UpdateSettingList(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, setEditBodySize } = React.useContext(CommonContext) as CommonContextType;
  const UpdateSettings = useSelector(
    (state: AppState) => state.UpdateSettings
  );
  const showModal = (record?: any) => {
    if (record.id) {
      setEditBodySize(record)
      setModelChange(true)
    }
  };
  const handleDelete = (id: number) => {
    dispatch(removeUpdateSetting(id));
   /*  messageApi.open({
      type: 'success',
      content: 'Product Type deleted successfully',
    }); */
  };
  return (
    <List
      className="demo-loadmore-list"
      itemLayout="horizontal"
      dataSource={UpdateSettings}
      renderItem={(item: any, index) => (
        <List.Item key={item.id}
          actions={[
            <EditOutlined style={{ color: '#018B98' }} onClick={() => showModal(item)} />,
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item.id)}>
              <DeleteOutlined style={{ color: 'red' }} />
            </Popconfirm>]}>
<div>
          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <div style={{ width: '20%' }}>iOS:</div>
              <div style={{ width: '30%' }}> v{item.ios_version} <br/>Title: {item.ios_title} <br /> Force Update: {JSON.stringify(item.ios_force_update)}<br/></div>
              <div style={{ width: '70%' }}>Redirection Link: {item.ios_redirection_ink}<br/>Message: {item.ios_message}</div>
          </div> <br/>
          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <div style={{ width: '20%' }}>Android:</div>
              <div style={{ width: '30%' }}> v{item.android_version} <br/>Title: {item.android_title} <br /> Force Update: {JSON.stringify(item.android_force_update)}<br/></div>
              <div style={{ width: '70%' }}>Redirection Link: {item.android_redirection_ink}<br/>Message: {item.android_message}</div>
          </div> <br/>
          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <div style={{ width: '20%' }}>Common:</div>
              <div style={{ width: '30%' }}> Title: {item.common_title} <br /> Active: {JSON.stringify(item.common_active)}</div>
              <div style={{ width: '70%' }}>Message: {item.common_message}</div>
          </div>
          </div>
          {/*   <div className='main_class'>
            <div className='sub_data'>iOS: v{item.ios_version} </div>
            <div className='sub_data'> Force Update{item.ios_version} </div>
          </div> */}
        </List.Item>
      )}
    />
  );
}